export default {
  view: {
    back: {
      title1: 'Twoja rejestracja jest przetwarzana.',
      title2: 'Potwierdzenie otrzymasz SMS-em',
      buttonTopup: 'Zarejestruj ponownie',
      buttonBack: 'Dalej',
      loading: `Zaczekaj. Trwa&nbsp;weryfikacja&nbsp;rejestracji...`
    }
  },
  component: {
    cookie: {
      text: 'Wyrażam zgodę na przechowywanie w moim urządzeniu plików cookies.',
      button: 'OK'
    },
    header: {
      title: 'Rejestracja karty SIM <span class="no-wrap">Plus</span>'
    },
    progress: {
      step1: 'Dane startera',
      step2: 'Weryfikacja',
      step3: 'Rejestracja'
    },
    register: {
      loadingText: 'Pobieranie danych...',
      labelPhone: 'Numer telefonu',
      labelEmail: 'Numer karty SIM',
      buttonNext: 'Dalej',
      title: '<strong>Krok 1</strong> - Podaj numer telefonu oraz karty SIM',
      placeholderEmail: 'podaj numer karty SIM',
      rodoText: 'Administratorem danych jest Polkomtel sp. z o.o., ul. Konstruktorska 4 w Warszawie. Dane będą przetwarzane w celu rejestracji karty SIM, na podstawie art. 6 ust. 1 lit. c RODO w związku z art. 60b Prawa telekomunikacyjnego oraz w celu zawarcia umowy na świadczenie usług telekomunikacyjnych, na podstawie art. 6 ust. 1 lit. b RODO. W związku z wyborem modelu weryfikacji danych, podstawą przetwarzania danych jest zgoda na uzyskanie przez Autopay S.A. z banku ING danych dotyczących mojej tożsamości oraz przekazanie tych danych do Polkomtel sp. z .o. o. w celu rejestracji karty SIM, jako dostawcy usług telekomunikacyjnych. Dane osobowe mogą być przekazywane następującym kategoriom odbiorców: podmiotom świadczącym administratorowi usługi niezbędne do realizacji wyżej wskazanych celów, w tym partnerom IT, podmiotom realizującym wsparcie techniczne lub w zakresie obsługi klienta. Przysługują Pani/Panu prawa do: wycofania zgody w dowolnym momencie (co nie wpływa na zgodność z prawem przetwarzania, które nastąpiło przed jej wycofaniem), sprostowania danych, dostępu do danych, ich usunięcia, ograniczenia przetwarzania, przenoszenia. Żądania te można składać na ww. adres Polkomtel sp. z o.o., a także: telefonicznie do Działu Obsługi Klienta (tel. 601102601), pocztą elektroniczną na adres bok@plus.pl, pisemnie lub ustnie w Punkcie sprzedaży (obsługi) lub do wyznaczonego Inspektora Ochrony Danych na adres: <a href="mailto:iod@plus.pl">iod@plus.pl</a>, ewentualne skargi do Prezesa Urzędu Ochrony Danych Osobowych. Szczegółowe informacje dotyczące przetwarzania danych oraz dane kontaktowe Polkomtel sp. z o.o. i wyznaczonego przez niego Inspektora Ochrony Danych są dostępne na <a href="http://www.plus.pl/dane-osobowe" target="_blank">www.plus.pl/dane-osobowe</a> (zakładka: „INFORMACJA POLKOMTEL SP. Z O.O. O PRZETWARZANIU DANYCH OSOBOWYCH KLIENTA/ABONENTA NA KARTĘ”).'
    },
    footer: {
      copyrights: '© {year} Polkomtel Sp. z o.o. Wszystkie prawa zastrzeżone'
    }
  },
  buttons: {
    logIn: `Zaloguj się`,
    register: 'Zarejestruj się'
  },
  validation: {
    invalid: 'Pole nieprawidłowe',
    required: 'Pole wymagane',
    operatorInvalid: 'Podaj numer Plus',
    simInvalid: 'Podaj poprawny numer karty SIM',
    phoneInvalid: 'Nieprawidłowy numer telefonu',
    registered: 'Ten numer jest już zarejestrowany',
    processError: 'Podczas przetwarzania danych wystąpił błąd!'
  },
  globalMessages: {
    userSessionTimeOut: 'Ze względów bezpieczeństwa zostałeś automatycznie wylogowany. Zaloguj się ponownie.'
  }
}
